module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _c('strong', [_vm._v("MORE CHEESE THAN LAMBEAU")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("LYRIC FROM SONG: "), _c('strong', [_vm._v("“CHECK 1, 2”")]), _vm._v(" ON ALBUM: "), _c('strong', [_vm._v("OUT OF BUSINESS")]), _vm._v(" BY ARTIST")]), _vm._v(": "), _c('strong', [_vm._v("EPMD")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The amount of money I have is much greater than the number of hats shaped like a type of milk-derived, protein-rich food worn by fans in support of the Green Bay Packers football team in their stadium in Wisconsin, a state known for its dairy products.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ea1ab3d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part01ch06.vue
// module id = 96
// module chunks = 0